import { Button, Radio, RadioChangeEvent } from "antd";
import React, { useState } from "react";
import { useViewerStore } from "../../../../../store/store";
import {
    flagToSunPositionVersion,
    SunPositionVersion,
    sunPositionVersionToFlag,
} from "../../../../../helpers/sunPositionVersion";

const SunPositionVersionModal = () => {
    const sceneViewer = useViewerStore((state) => state.sceneViewer);
    const currentVersion = flagToSunPositionVersion(
        useViewerStore.getState().useDesignCenteredSunPosition,
    );
    const [selectedVersion, setSelectedVersion] = useState<SunPositionVersion>(currentVersion);

    const onChange = (e: RadioChangeEvent) => {
        setSelectedVersion(e.target.value as SunPositionVersion);
    };

    const confirm = () => {
        useViewerStore.setState({
            useDesignCenteredSunPosition: sunPositionVersionToFlag(selectedVersion),
        });
        sceneViewer.viewerAlert({ show: false });
        sceneViewer.refreshShade();
    };

    const cancel = () => {
        sceneViewer.viewerAlert({ show: false });
    };

    return (
        <>
            <p style={{ marginBottom: "1rem" }}>
                Recalculate shade using the selected sun position logic for this design.
            </p>
            <Radio.Group
                onChange={onChange}
                value={selectedVersion}
                style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: "1.5rem" }}
            >
                <Radio value="legacy">Legacy Sun Position</Radio>
                <Radio value="updated">Updated Sun Position</Radio>
            </Radio.Group>
            <div className={"modal-bottom-action-button-container"}>
                <Button
                    type="primary"
                    size="large"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirm}
                >
                    Confirm
                </Button>
                <Button
                    type="primary"
                    size="large"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancel}
                >
                    Cancel
                </Button>
            </div>
        </>
    );
};

export default SunPositionVersionModal;
